
export function optoutActionDetails() {
    return {
      restrict: 'E',
      template: require('./optout-action-details.directive.html'),
      scope: {
        action: "=",
        optins: "=",
      },
      controller: OptoutActionDetailsController
    };
  }
  
  OptoutActionDetailsController.$inject = ['$scope'];
  function OptoutActionDetailsController($scope) {
  
    $scope.selectOptin = selectOptin;
  
    init();
  
    function selectOptin(optin) {
      $scope.action.selectedOptin = optin;
    }
  
    function init() {
      let selectedOptin = {};
      if ($scope.optins) {
        if ($scope.action.optin && $scope.action.optin.id) {
          selectedOptin = $scope.optins.find(optin => optin.id == $scope.action.optin.id);
        } else {
          if ($scope.optins.length > 0) {
            selectedOptin = $scope.optins[0];
          }
        }
      }
      $scope.action.selectedOptin = selectedOptin;
    }
  }
  